import React from 'react';

interface AppStoreLinksProps {
  className?: string;
}

const AppStoreLinks: React.FC<AppStoreLinksProps> = ({ className = '' }) => {
  // Placeholder URLs - replace with actual app store links when available
  const appleStoreUrl = 'https://apps.apple.com/app/fiestalbum'; // Placeholder
  const androidStoreUrl = 'https://play.google.com/store/apps/details?id=com.fiestalbum'; // Placeholder

  const handleAppleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    // TODO: Replace with actual Apple App Store URL when available
    window.open(appleStoreUrl, '_blank', 'noopener,noreferrer');
  };

  const handleAndroidClick = (e: React.MouseEvent) => {
    e.preventDefault();
    // TODO: Replace with actual Google Play Store URL when available
    window.open(androidStoreUrl, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className={`app-store-links ${className}`}>
      {/* Apple App Store Icon */}
      <a
        href={appleStoreUrl}
        onClick={handleAppleClick}
        className="app-store-link apple-store"
        title="Download on the App Store"
        aria-label="Download on the App Store"
      >
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="currentColor"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M17.05 20.28c-.98.95-2.05.88-3.08.4-1.09-.5-2.08-.48-3.24 0-1.44.62-2.2.44-3.06-.4C1.79 15.25 4.96 6.39 9.38 6.39c1.34 0 2.18.81 3.24.81 1.01 0 1.65-.79 3.24-.79 2.83 0 4.7 2.03 6.15 4.95-5.34 2.88-4.48 9.92-4.96 10.92zM12.03 6.39c-.31-2.58 2.14-4.84 4.78-5.12.38 2.55-2.05 4.78-4.78 5.12z" />
        </svg>
      </a>

      {/* Google Play Store Icon */}
      <a
        href={androidStoreUrl}
        onClick={handleAndroidClick}
        className="app-store-link android-store"
        title="Get it on Google Play"
        aria-label="Get it on Google Play"
      >
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="currentColor"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M3,20.5V3.5C3,2.91 3.34,2.39 3.84,2.15L13.69,12L3.84,21.85C3.34,21.6 3,21.09 3,20.5M16.81,15.12L6.05,21.34L14.54,12.85L16.81,15.12M20.16,10.81C20.5,11.08 20.75,11.5 20.75,12C20.75,12.5 20.53,12.9 20.18,13.18L17.89,14.5L15.39,12L17.89,9.5L20.16,10.81M6.05,2.66L16.81,8.88L14.54,11.15L6.05,2.66Z" />
        </svg>
      </a>
    </div>
  );
};

export default AppStoreLinks;
